import { AxiosRequestConfig } from "axios";
import { Text } from "components";
import DashboardNavbar from "components/DashboardNavbar";
import { Search } from "lucide-react";
import { useDebounce } from "pages/CreateDeal/newdeal";
import {
  getRelativeDate,
  isValidIndianMobile,
} from "pages/Opportunities/utils/featureRule";
import { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactSelect, {
  components,
  MenuProps,
  OptionProps,
  SingleValue,
  StylesConfig,
} from "react-select";
import {
  setContactPersonName,
  setContactPersonPhone,
} from "redux/features/CreateOpportunity";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  getDashboardStats,
  GetDashboardStatsRequestType,
} from "service/apis/Dashboard";
import {
  searchContact1,
  SearchContactReqType,
} from "service/apis/Opportunities";
import { toast } from "sonner";
import { formatIndianNumber } from "../../utils";
import { buttonData, ContactData } from "./dashboard-data";
import { LEVEL_2, LEVEL_3 } from "common/constants";
import { checkLevel } from "common/rules";
import { RowDetailsSheet } from "pages/Opportunities/opportunitydetails";
import PreparequoteHomepageLevel1 from "./PrepQuote/PrepareQuoteHomepage";
import PreparequoteHomepageLevel2 from "./PrepQuote/PrepareQuoteHomepageLevel2";
import { LiveRateSlider } from "./LiveRate";

import { useQuery } from "react-query";
import { getDealStats } from "./api";

interface CustomMenuProps extends MenuProps<ContactData, false> {
  business?: boolean; // Add the custom prop
}

const CustomMenu: React.FC<CustomMenuProps> = ({
  children,
  business,
  ...props
}) => {
  const navigate = useNavigate();
  const { pipelineType } = useAppSelector((state) => state.CreateOpportunity);

  const handleAddContact = (e: React.MouseEvent) => {
    e.preventDefault(); // Prevent default behavior
    e.stopPropagation(); // Stop event bubbling
    navigate(buttonData[pipelineType].href);
  };
  return (
    <components.Menu {...props}>
      {!checkLevel(LEVEL_2) && !business && (
        <div className="bg-[#F9F9F9] h-[33px] p-2 w-full justify-end flex gap-2">
          <div className="flex items-center gap-1">
            <p className="bg-[#E1EBFC] p-1 rounded font-normal text-xs leading-[16.8px]">
              P
            </p>
            <p className="font-normal text-xs leading-[16.8px] text-[#999999]">
              Partner
            </p>
          </div>
          <div className="flex items-center gap-1">
            <p className="bg-[#E1EBFC] p-1 rounded font-normal text-xs leading-[16.8px]">
              C
            </p>
            <p className="font-normal text-xs leading-[16.8px] text-[#999999]">
              Corporate
            </p>
          </div>
        </div>
      )}
      {children}
      {(!checkLevel(LEVEL_2) || props.options.length === 0) &&
        (props.selectProps.inputValue.length !== 10 ||
          !props.options.length) && (
          <div>
            <button
              className="bg-blue-700 w-full absolute text-white-A700 p-2 rounded-b-xl"
              onClick={handleAddContact}
              onTouchEnd={(e) => {
                e.preventDefault(); // Prevent default touch behavior
                handleAddContact(e as unknown as React.MouseEvent);
              }}
            >
              {buttonData[pipelineType].label}
            </button>
          </div>
        )}
    </components.Menu>
  );
};

const CustomOption: React.FC<OptionProps<ContactData, false>> = ({
  innerProps,
  label,
  data,
  isFocused,
}) => (
  <div
    {...innerProps}
    style={{
      padding: "8px 12px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
      backgroundColor: isFocused ? "#F3F7FF" : "inherit",
      color: data.status === "Blocked" ? "red" : "inherit",
    }}
  >
    {checkLevel(LEVEL_2) ? (
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <tbody>
          <tr>
            <td style={{ width: "40%" }}>
              <div className=" first-letter:uppercase">
                {data.partnerType && !data?.companyName && (
                  <span className="bg-[#E1EBFC] p-1 mr-2 rounded font-normal text-xs leading-[16.8px]">
                    P
                  </span>
                )}
                {data.companyName && (
                  <span className="bg-[#E1EBFC] p-1 mr-2 rounded font-normal text-xs leading-[16.8px]">
                    C
                  </span>
                )}
                {data?.contactName}
              </div>
            </td>
            <td style={{ width: "27%", textAlign: "left" }}>
              <div>{data?.contactPhone}</div>
            </td>
            {/* <td style={{ width: '25%' }} className="">
            <div style={{ fontSize: '0.8em', color: '#666' }}>{data.location ? data?.location : "N/A"}</div>
          </td> */}
            <td style={{ width: "33%", textAlign: "right" }}>
              <div
                style={{
                  display: "inline-block",
                  padding: "2px 6px",
                  borderRadius: "12px",
                  fontSize: "0.8em",
                  color: "black",
                }}
              >
                {data?.contactType === "individual" ? "Contact" : "Customer"}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    ) : (
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <tbody>
          <tr>
            <td style={{ width: "40%" }}>
              <div className=" first-letter:uppercase">
                {data.partnerType && !data?.companyName && (
                  <span className="bg-[#E1EBFC] p-1 mr-2 rounded font-normal text-xs leading-[16.8px]">
                    P
                  </span>
                )}
                {data.companyName && (
                  <span className="bg-[#E1EBFC] p-1 mr-2 rounded font-normal text-xs leading-[16.8px]">
                    C
                  </span>
                )}
                {data.partnerType && !data?.companyName
                  ? data?.name
                  : data?.companyName
                  ? data?.companyName
                  : data?.contactName}
              </div>
            </td>
            <td style={{ width: "27%", textAlign: "left" }}>
              <div>{}</div>
            </td>
            {/* <td style={{ width: '25%' }} className="">
            <div style={{ fontSize: '0.8em', color: '#666' }}>{data.location ? data?.location : "N/A"}</div>
          </td> */}
            <td style={{ width: "33%", textAlign: "right" }}>
              <div
                style={{
                  display: "inline-block",
                  padding: "2px 6px",
                  borderRadius: "12px",
                  fontSize: "0.8em",
                  color: "black",
                }}
              >
                {data?.customer_types?.some((item) =>
                  ["Contact", "Customer"].includes(item)
                )
                  ? "Individual"
                  : data.partnerType
                  ? data?.partnerType.split("_").join(" ")
                  : data?.companyName
                  ? data?.type
                  : data?.contactType}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    )}
  </div>
);

function SearchAndTab() {
  const [inputValue, setInputValue] = useState<string>("");
  const [options, setOptions] = useState<Partial<ContactData[]>>([]);
  const [checkContactType, setCheckContactType] = useState<{
    [key: string]: boolean;
  }>({
    individual: false,
    business: false,
  });

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleChange = (newValue: SingleValue<ContactData>) => {
    if (!newValue) return;
    if (newValue?.companyName && newValue?.role === "lead") {
      navigate(`/leads/corporate/${newValue?.value}`);
      return;
    }
    if (
      newValue?.customer_types?.some((item) =>
        ["Contact", "Customer"].includes(item)
      )
    ) {
      navigate(`/customerdetails/${newValue?.value}`);
      return;
    }
    if (newValue?.partnerType && !newValue?.companyName) {
      if (newValue?.role === "lead") {
        navigate(`/leads/partner/${newValue?.value}`);
      } else navigate(`/partnerdetails/${newValue?.value}`);
    } else if (!newValue?.companyName && !newValue?.isCustomer) {
      navigate(`/leads/contact/${newValue?.value}`);
    } else if (!newValue?.companyName && newValue?.isCustomer) {
      if (
        !newValue?.linked_customer_id ||
        Number(newValue?.linked_customer_id) === 0
      ) {
        navigate(`/leads/contact/${newValue?.value}`);
      } else {
        navigate(`/customerdetails/${newValue?.linked_customer_id}`);
      }
    }
  };

  const fetchSearchResults = async () => {
    if (checkLevel(LEVEL_2) && inputValue.length < 10) {
      return;
    }
    if (!inputValue) {
      return;
    }
    const auth = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);
    const payload: AxiosRequestConfig<SearchContactReqType> = {
      headers: { Authorization: `Bearer ${authToken}` },
      params: {
        searchQuery: inputValue,
        contactType: checkContactType?.individual
          ? "individual"
          : checkContactType?.business
          ? "business"
          : null,
      },
    };
    try {
      if (inputValue === "") return;
      const response = (await searchContact1(payload)) as any;
      if (response?.data?.length === 0) {
        setOptions(() => []);
        return;
      }
      let newOptions: ContactData[];
      if (checkLevel(LEVEL_2)) {
        newOptions = response?.data?.combined_record?.map((item: any) => ({
          value: item?.id,
          label: item?.contactName,
          contactName: item?.full_name || item?.contactName,
          contactPhone: item?.phone_number || item?.contactNumber,
          email: item?.contactEmail,
          role: item?.status,
          location: item?.contactAddress?.[0],
          status: item?.status,
          type: item?.contactPersonType,
          partnerType: item?.type,
          contactType: item?.contactPersonType,
          name: item?.name,
          phone: item?.phone,
          companyName: item?.company_name,
          lead_status: item?.lead_status,
          isCustomer: item?.customer,
          linked_customer_id: item?.linked_customer_id,
          customer_types: item?.customer_types || [],
        }));
      } else
        newOptions = response?.data?.combined_record?.map((item: any) => ({
          value: item?.id,
          label: item?.contactName,
          contactName: item?.full_name || item?.contactName,
          contactPhone: item?.phone_number || item?.contactNumber,
          email: item?.contactEmail,
          role: item?.status,
          location: item?.contactAddress?.[0],
          status: item?.status,
          type: item?.contactPersonType,
          partnerType: item?.type,
          contactType: item?.contactPersonType,
          name: item?.name,
          phone: item?.phone,
          companyName: item?.company_name,
          lead_status: item?.lead_status,
          isCustomer: item?.customer,
          linked_customer_id: item?.linked_customer_id,
          customer_types: item?.customer_types || [],
        }));
      setOptions(newOptions);
    } catch (error) {
      if (error.response?.status === 429) {
        toast.error("Search limit exceeded.", {
          description:
            "You have exceeded the limit of requests. Please try again later.",
        });
      }
      console.error("Error fetching options:", error);
    }
  };

  useDebounce(() => fetchSearchResults(), 500, [inputValue]);

  const customStyles: StylesConfig<ContactData> = {
    control: (provided, state) => ({
      ...provided,
      zIndex: 0,
      borderRadius: "1.75rem",
      height: "3rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      paddingLeft: "40px",
      borderColor: state.isFocused ? "#165FE3" : "#d2d2d2",
      boxShadow: "none",
      width: "100%",
    }),
    menu: (provided) => ({
      ...provided,
      padding: 0,
      maxHeight: "300px",
      display: (() => {
        if (checkLevel(LEVEL_2) && inputValue.length < 10) {
          return "none";
        }
        return inputValue ? "block" : "none";
      })(),
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
      width: "100%",
      maxHeight: "240px",
    }),
    option: (provided) => ({
      ...provided,
      width: "100%",
      display: "flex",
      borderRadius: "12px",
      justifyContent: "space-between",
      background: "#000000",
    }),
    placeholder: (provided) => ({
      ...provided,
      "@media (max-width: 768px)": {
        fontSize: "16px",
      },
      "@media (max-width: 480px)": {
        fontSize: "13px",
      },
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      display: "none",
    }),
  };

  const placeholder = (): string => {
    if (checkLevel(LEVEL_2)) {
      return "Search by mobile number";
    }
    if (checkLevel(LEVEL_3)) return "Search by name or mobile number";

    return "Search by name or mobile number";
  };

  const handleCheckChange = (
    e: ChangeEvent<HTMLInputElement>,
    type: string
  ) => {
    const check = e.target.checked;
    if (type === "individual") {
      setCheckContactType((prev) => ({
        ...prev,
        individual: check,
        business: false,
      }));
    }
    if (type === "business") {
      setCheckContactType((prev) => ({
        ...prev,
        business: check,
        individual: false,
      }));
    }
  };

  return (
    <div className="py-10 px-5 flex items-center flex-col gap-8 rounded-xl bg-white-A700">
      <div className="flex gap-2 items-center flex-col w-full sm:max-w-xl max-w-2xl">
        {!checkLevel(LEVEL_2) && (
          <div className="flex gap-2 items-center w-full px-4 justify-end">
            <div className="flex gap-2 items-center">
              <input
                onChange={(e) => handleCheckChange(e, "individual")}
                checked={checkContactType?.individual}
                className="rounded-sm disabled:opacity-40"
                type="checkbox"
                name="individual"
                id="individual"
              />
              <label
                aria-disabled={checkContactType?.business}
                className="select-none disabled:opacity-40 font-medium text-sm leading-[19.6px] text-[#666666]"
                htmlFor="individual"
              >
                Individual
              </label>
            </div>
            <div className="flex gap-2 items-center">
              <input
                onChange={(e) => handleCheckChange(e, "business")}
                checked={checkContactType?.business}
                className="rounded-sm disabled:opacity-40"
                type="checkbox"
                name="business"
                id="business"
              />
              <label
                aria-disabled={checkContactType?.individual}
                className="select-none disabled:opacity-40 font-medium text-sm leading-[19.6px] text-[#666666]"
                htmlFor="business"
              >
                Business
              </label>
            </div>
          </div>
        )}
        <div className=" relative flex items-center w-full">
          <ReactSelect<ContactData>
            placeholder={placeholder()}
            styles={customStyles}
            components={{
              Option: CustomOption,
              Menu: (menuProps) => (
                <CustomMenu
                  {...menuProps}
                  business={checkContactType?.individual}
                />
              ),
            }}
            isClearable
            isSearchable
            name="company"
            inputValue={inputValue}
            onChange={handleChange}
            options={options as ContactData[]}
            onInputChange={(value) => {
              if (value.length === 0) {
                dispatch(setContactPersonPhone(""));
                dispatch(setContactPersonName(""));
                setOptions(() => []);
              }
              if (checkLevel(LEVEL_2)) {
                if (/^\d*$/.test(value)) {
                  setInputValue(value);
                }
              } else setInputValue(value);
              if (isValidIndianMobile(value))
                dispatch(setContactPersonPhone(value));
              else if (!value.match(/^\d+$/))
                dispatch(setContactPersonName(value));
            }}
            className="w-full disabled:opacity-40"
            filterOption={null}
          />
          <Search className="absolute left-2 h-3.5" />
        </div>
      </div>
    </div>
  );
}

const DashboardPage: React.FC = () => {
  // skipcq: JS-0323, JS-0323
  const [state, setState] = useState<any>();
  const [, setLoading] = useState<boolean>(false);
  const [showStats, setShowStats] = useState<boolean>(false);
  const [isShow, setIsShow] = useState<boolean>(false)
  const [tabSwitch, setTabSwitch] = useState<boolean>(false);
  const [showScrollIndicator, setShowScrollIndicator] = useState(true);
  const [loadImg, setLoadImg] = useState(true);
  const [isRowDetailsOpen, setIsRowDetailsOpen] = useState(false);

  const id = new URLSearchParams(window.location.search).get("id");
  const product = new URLSearchParams(window.location.search).get("product");
  const create_date = new URLSearchParams(window.location.search).get(
    "create_date"
  );

  const scrollRef = useRef<HTMLDivElement>(null);

  const handleScrollDown = () => {
    const scrollContainer = document.querySelector(".scroll-container");
    if (scrollContainer) {
      const scrollAmount = 500; // Adjust this value to control how far it scrolls
      scrollContainer.scrollBy({
        top: scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const handleScroll = () => {
    setShowScrollIndicator(false);
  };

  useEffect(() => {
    const scrollDiv = scrollRef.current;
    if (scrollDiv) {
      scrollDiv.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollDiv) {
        scrollDiv.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const getDashboardStatsData = () => {
    setLoading(true);
    const auth: string | null = localStorage.getItem("authToken");
    if (auth === null) return;
    const authToken = JSON.parse(auth);

    const payload: AxiosRequestConfig<GetDashboardStatsRequestType> = {
      headers: { Authorization: authToken },
    };

    getDashboardStats(payload)
      .then((res) => {
        setState(res.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const { data: dealData } = useQuery({
    queryKey: ["deal-stats"],
    queryFn: getDealStats,
    staleTime: 1000 * 3600, // 1 hour
  });

  const greeting = () => {
    const hour = new Date().getHours();
    if (hour >= 5 && hour < 12) {
      return {
        greet: "Good Morning",
        image: "images/overview/day.png",
        color: "#5597B2",
      };
    } else if (hour >= 12 && hour < 18) {
      return {
        greet: "Good Afternoon",
        image: "images/overview/evening.png",
        color: "#FFA52D",
      };
    } else {
      return {
        greet: "Good Evening",
        image: "images/overview/night.png",
        color: "#FFA52D",
      };
    }
  };

  useEffect(() => {
    getDashboardStatsData();
  }, []);

  const navLinks = {
    current: {
      label: "All Overview",
      icon: "",
    },
    left: [
      {
        label: "Remit",
        href: "/remit",
        icon: "images/overview/remit.svg",
        logo: "images/overview/remit-text.svg",
        enabled: true,
      },
      {
        label: "Forex",
        href: "/overview",
        icon: "images/overview/forex.svg",
        logo: "images/overview/forex-text.svg",
        enabled: false,
      },
      {
        label: "Corporate",
        href: "/overview",
        icon: "images/overview/corporate.svg",
        logo: "images/overview/corporate-text.svg",
        enabled: false,
      },
    ],
    right: [
      {
        label: "Notification",
        visible: false,
        href: "#",
        icon: "images/overview/bell.svg",
        submenu: [],
        enabled: true,
      },
      // {
      //   label: "Settings",
      //   visible: false,
      //   href: "#",
      //   icon: "images/overview/settings.svg",
      //   submenu: [],
      //   enabled: true,
      // },
      {
        label: "Profile",
        visible: false,
        href: "#",
        icon: "images/overview/profile.svg",
        submenu: [
          {
            label: "My Profile",
            href: "/profile",
            icon: "images/overview/myprofile.svg",
          },
          ...(checkLevel(LEVEL_2)
            ? [
                {
                  label: "My Company",
                  href: "/mycompany",
                  icon: "images/MyCompany.svg",
                },
              ]
            : []),
          {
            label: "Logout",
            href: "/logout",
            icon: "images/overview/logout.svg",
          },
        ],
        enabled: true,
      },
      // {
      //   label: "Help",
      //   visible: true,
      //   href: "#",
      //   icon: "images/overview/wrench.svg",
      //   submenu: [
      //     {
      //       label: "Documents",
      //       href: "#",
      //       icon: "images/overview/myprofile.svg",
      //     },
      //     {
      //       label: "Youtube Tutorials",
      //       href: "#",
      //       icon: "images/overview/myprofile.svg",
      //     },
      //     {
      //       label: "Contact Support",
      //       href: "#",
      //       icon: "images/sidebar_img/contact.svg",
      //     },
      //   ],
      //   enabled: true,
      // },
      // {
      //   label: "plus",
      //   visible: false,
      //   href: "#",
      //   icon: "images/overview/btn.svg",
      //   submenu: [
      //     {
      //       label: "Create Deals",
      //       href: "/createnewdeal",
      //       icon: "/images/sidebar_img/remit.svg",
      //     },
      //     {
      //       label: "Create Orders",
      //       href: "/createorder",
      //       icon: "/images/sidebar_img/remit.svg",
      //     },
      //     {
      //       label: "View Orders",
      //       href: "/remit/orders",
      //       icon: "/images/sidebar_img/remit.svg",
      //     },
      //     {
      //       label: "Create FX Quote",
      //       href: "/createforexQuotation",
      //       icon: "/images/sidebar_img/remit.svg",
      //     },
      //     {
      //       label: "Create Remit Quote",
      //       href: "/createRemittanceQuotation",
      //       icon: "/images/sidebar_img/remit.svg",
      //     },
      //   ],
      //   enabled: true,
      // },
    ],
  };

  useEffect(() => {
    setIsRowDetailsOpen(!!id && !!product && !!create_date);
  }, []);

  useEffect(() => {
    const img = new Image();
    img.src = greeting().image;
    img.onload = () => {
      setLoadImg(false);
    };
  }, [greeting().image]);

  return (
    <>
      {id && product && create_date && (
        <RowDetailsSheet
          isOpen={isRowDetailsOpen}
          onOpenChange={setIsRowDetailsOpen}
          rowData={{
            id,
            product,
            createDate: getRelativeDate(Number(create_date)),
          }}
          getOpportunityList={() => {}}
        />
      )}
      <div className="bg-gray-100 min-h-screen  gap-4 sm:h-auto flex flex-col font-inter w-full">
        <DashboardNavbar navLinks={navLinks} />
        <LiveRateSlider />
        <section className="flex flex-col h-full gap-4 w-full overflow-hidden sm:overflow-auto">
          <SearchAndTab />

          <div className="flex gap-4 flex-col">
            <div className="w-full h-full bg-white-A700 rounded-xl">
              <div className="h-full p-4">
                <PreparequoteHomepageLevel2 />
              </div>
            </div>
            <div className="w-full h-full flex flex-col bg-white-A700 rounded-xl">
              <div className="p-4 border-b">
                <div className="flex w-full text-sm justify-between">
                  <span className="text-[#333333] font-semibold">Stats</span>
                  <button
                    role="button"
                    aria-hidden
                    onClick={() => setShowStats(!showStats)}
                    className="font-semibold underline cursor-pointer text-[#165FE3] disabled:opacity-40 disabled:cursor-not-allowed"
                  >
                    {!showStats ? "Hide" : "Show"}
                  </button>
                </div>
              </div>
              <div className="flex-1 overflow-auto p-4 h-full">
                {!showStats && (
                  <div className="flex flex-wrap gap-3">
                    {dealData?.map((item: any, index: number) => (
                      <div
                        key={index}
                        className="w-full lg:w-[48%] bg-white-A700 rounded-xl border gap-[14px] py-4 px-5"
                      >
                        <div className="bg-white-A700 flex flex-1 flex-col gap-[5px] items-start justify-center rounded-[10px] w-full">
                          <Text
                            className="text-blue-700 text-sm w-full"
                            size="txtInterSemiBold14"
                          >
                            {item.name}
                          </Text>
                          <div className="flex flex-row gap-[5px] items-center justify-between w-full">
                            <Text
                              className="text-gray-600_01 text-xs w-auto"
                              size="txtInterRegular12Gray60001"
                            >
                              Today
                            </Text>
                            <Text
                              className="text-red-500 text-xs w-auto"
                              size="txtInterSemiBold12"
                            >
                              {item.today}
                            </Text>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default DashboardPage;
